








































import SvgIcon from '@/components/common/svg-icon.vue';
import { useHalfTask } from '@/hooks/use-half-task';
import { getTaskOrder, useTaskStore } from '@/store/task';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { computed, defineComponent } from '@vue/composition-api';
import { useLocalStorage } from '@vueuse/core';
import dayjs from 'dayjs';
import { storeToRefs } from 'pinia';
import TaskListVue from './task-list.vue';
import { TaskItem } from '@/types/task';
import RollingList from '@/components/rolling-list/rolling-list.vue';
import Stamp from '@/components/stamp-module/stamp-item.vue';
import { language } from '@tencent/ppd-base-libs';

export default defineComponent({
  components: {
    SvgIcon,
    TaskListVue,
    RollingList,
    Stamp,
  },
  setup() {
    const getStorageKey = () => `E-MONTH-TASK-UPDATED-TIP-${dayjs(getServerTime()).format('YYYYMM')}`;
    const isShowMonthTaskTip = useLocalStorage(getStorageKey(), true);  // 每个月提示一次

    const {
      taskGroupList,
      summarySecondaryTasks,
      summaryMainTasks,
    } = storeToRefs(useTaskStore());

    /** 全部任务数 */
    // eslint-disable-next-line max-len
    const taskTotalCount = computed(() => taskGroupList.value.reduce((total, item) => total + item.taskInfoList.length, 0));

    /** 点击拉起半屏弹层展示任务列表 */
    const { showHalfTask } = useHalfTask();
    const taskNameIdList = computed(() => summaryMainTasks.value.map(item => item.id));
    const sortTaskListFunc = (a: TaskItem, b: TaskItem) => getTaskOrder(b) - getTaskOrder(a);

    const isLangEn = language.isEn();
    const secondaryTaskItemHeight = isLangEn ? 48 : 24;

    return {
      isShowMonthTaskTip,

      /** 全部任务查看引导文案 */
      taskTotalCount,

      /** 任务列表 */
      taskNameIdList,
      sortTaskListFunc,

      viewAllTasks: () => {
        isShowMonthTaskTip.value = false;
        showHalfTask();
      },

      secondaryTasks: summarySecondaryTasks,

      isLangEn,
      secondaryTaskItemHeight,
    };
  },
});
